// Animates server-rendered draft text as if it were being typed.
// Used for AI draft messages: the element remounts per draft (its id includes
// a hash of the body), so `mounted` runs once for each new draft.
//
// Supports:
// - plain <textarea> (SMS compose): animates `el.value`
// - SuperText (email compose): set `data-typewriter-text` + `data-typewriter-target`
//   (id of the `[data-supertext-value]` source). Starts the editor empty and
//   reveals text via that attribute so TipTap picks it up without LiveView noise.
export default {
  Typewriter: {
    mounted() {
      this.fullText = this.el.getAttribute('data-typewriter-text') || this.el.value || '';
      this.pos = 0;
      this.frame = null;
      this.targetId = this.el.getAttribute('data-typewriter-target');
      if (!this.fullText) return;

      this.applyText('');
      const startedAt = performance.now();
      // Scale duration with length, clamped so short drafts still animate
      // and long ones don't drag on.
      const duration = Math.min(2500, Math.max(700, this.fullText.length * 18));

      const step = now => {
        const progress = Math.min(1, (now - startedAt) / duration);
        this.pos = Math.ceil(progress * this.fullText.length);
        this.applyText(this.fullText.slice(0, this.pos));
        this.frame = progress < 1 ? requestAnimationFrame(step) : null;
      };

      this.frame = requestAnimationFrame(step);
    },

    updated() {
      // LiveView patches (e.g. the countdown ticking every second) can restore
      // the full server-rendered value mid-animation; reapply the typed prefix.
      if (this.frame && this.fullText && this.pos < this.fullText.length) {
        this.applyText(this.fullText.slice(0, this.pos));
      }
    },

    destroyed() {
      if (this.frame) cancelAnimationFrame(this.frame);
    },

    applyText(text) {
      if (this.targetId) {
        const source = document.getElementById(this.targetId);
        if (source) source.setAttribute('data-supertext-value', text);
      } else {
        this.el.value = text;
      }

      const scrollEl = this.targetId ? document.getElementById(this.targetId)?.querySelector('.ProseMirror') : this.el;
      if (scrollEl) scrollEl.scrollTop = scrollEl.scrollHeight;
    },
  },
};
